module.exports = __webpack_public_path__ + "static/images/hero-bg.1833fc84597244f1bf82a57a893889e1.jpg";